import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { InternationalizationNameSpace } from '~/constants/internationalization-namespace';

const useGeneralTranslationsWrapper = () => {
  const { t } = useTranslation([InternationalizationNameSpace.Legacy]);
  const translate = useCallback((key: string, values?: any) => t(key, values), [t]);
  return { t: translate };
};
export { useGeneralTranslationsWrapper };
